import { Backdrop } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
export default function Loading({ children, invisible, open, transitionDuration, onClick }) {
  const classes = useStyles();

  return (
    <div>
      <Backdrop
        className={classes.backdrop}
        open={open}
        onClick={onClick}
        invisible={invisible}
        transitionDuration={transitionDuration}
      >
        {children}
      </Backdrop>
    </div>
  );
}
Loading.propTypes = {
  children: PropTypes.node,
  invisible: PropTypes.bool,
  open: PropTypes.bool,
  transitionDuration: PropTypes.number,
};

Loading.defaultProps = {};
